import React, { useState, useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Sticky from "react-sticky-el";
import {
  fetchPressRelease,
  fetchPublicationIds,
} from "../../../actions/filters-actions";
import {
  DASHBOARD,
  DASHBOARD_CONTAINER,
  WIDGET,
} from "../../../constants/route-constants";
import {
  FILTER_NAMES,
  VERTICALS,
  CONSTANTS,
  REPORT_CATEGORIES,
  LANGUAGE_CODES,
  SOCIAL_SOURCES,
} from "../../../constants/app-constant";
import {
  ArrowDownIcon,
  FilterIcon,
  MenuIcon,
} from "../../Icons/icons.component";
import {
  Journalist,
  Sentiments,
  ShareOfVoice,
  ThematicAnalysis,
  KeywordCloud,
  Geo,
  Spokesperson,
  Publication,
} from "./AnalysisGroup";
import DateRangeFilter from "../Filters/DateRangeFilter";
import Filters from "../Filters/Filters";
import LazyLoad from "react-lazy-load";
import { httpGet } from "../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../constants/api-endpoint";
import {
  journalistWidgetList,
  keywordWidgetList,
  publicationWidgetList,
  sovWidgetList,
  taWidgetList,
  sentimentWidgetList,
  geoLocationWidgetList,
  spokesWidgetList,
  getWidgetsBySettings,
} from "./AnalysisGroup/filter-constant";
import {
  getConceptUserId,
  sortArrayOfObjects,
} from "../../../utility/common-methods";
import {
  SOCIAL_SOURCES_OPTIONS,
  TONALITY_FILTER,
  QUALITATIVE_CHART_TYPE_FILTERS,
} from "../../../constants/static-filter";
import ConceptLogo from "../../../assets/images/conceptbiu-logo.png";
import { fetchInlineFilter } from "../../../actions/widget-action";

const {
  V_PRINT,
  V_ONLINE,
  V_SOCIAL,
  V_PRINT_AND_ONLINE,
  V_BLOG,
  V_FORUM,
  V_BLOGS_AND_FORUMS,
} = VERTICALS;

const isPrintAndOnline = (vertical) => {
  return (
    vertical.indexOf(VERTICALS.V_PRINT) !== -1 ||
    vertical.indexOf(VERTICALS.V_ONLINE) !== -1
  );
};

const { EMPTY_ARRAY, EMPTY_STRING, EMPTY_OBJECT } = CONSTANTS;
const {
  EDITION,
  PUBLICATION_TYPE,
  ENTITY,
  PUBLICATION_IDS,
  TYPED_PUBLICATION_TEXT,
  REMOVE_PUBLICATION_TEXT,
  VERTICAL,
  PRESS_RELEASE,
  LANGUAGES,
  COUNTRIES,
  PLATFORM,
  TONALITY_MULT,
  CHART_TYPE,
} = FILTER_NAMES;

const {
  PUBLICATION,
  JOURNALIST,
  KEYWORD_CLOUD,
  SOV,
  CITY,
  INFLUENCERS,
  REACH,
  SENTIMENT,
  TOP_POSTERS,
  TOP_LANGUAGES,
  CITY_SPECIFIC_REPORT,
  TAG_ANALYSIS,
  THEMATIC_ANALYSIS,
  GEOLOCATION,
  SPOKESPERSON,
} = REPORT_CATEGORIES;

const settings = [
  // {
  //   "id": 1,
  //   "client_id": 8,
  //   "graph_type": "Share of Voice",
  //   "entity_level": true,
  //   "publication_level": true,
  //   "journalist_level": true,
  //   "city_level": true,
  //   "keyword_level": true,
  //   "spokesperson_level": false,
  //   "profiling_level": false,
  //   "visibility_level": false,
  //   "topic_level": false,
  //   "client_name": "Tata Motors",
  //   "graph_id": 1
  // },
  // {
  //   "id": 2,
  //   "client_id": 8,
  //   "graph_type": "Thematic Analysis",
  //   "entity_level": true,
  //   "publication_level": true,
  //   "journalist_level": true,
  //   "city_level": true,
  //   "keyword_level": true,
  //   "spokesperson_level": false,
  //   "profiling_level": false,
  //   "visibility_level": false,
  //   "topic_level": false,
  //   "client_name": "Tata Motors",
  //   "graph_id": 2
  // },
  // {
  //   "id": 3,
  //   "client_id": 8,
  //   "graph_type": "Geographical Spread",
  //   "entity_level": true,
  //   "publication_level": true,
  //   "journalist_level": false,
  //   "city_level": false,
  //   "keyword_level": true,
  //   "spokesperson_level": false,
  //   "profiling_level": false,
  //   "visibility_level": false,
  //   "topic_level": false,
  //   "client_name": "Tata Motors",
  //   "graph_id": 3
  // },
  // {
  //   "id": 4,
  //   "client_id": 8,
  //   "graph_type": "Journlist",
  //   "entity_level": true,
  //   "publication_level": false,
  //   "journalist_level": false,
  //   "city_level": false,
  //   "keyword_level": true,
  //   "spokesperson_level": false,
  //   "profiling_level": false,
  //   "visibility_level": false,
  //   "topic_level": false,
  //   "client_name": "Tata Motors",
  //   "graph_id": 4
  // },
  // {
  //   "id": 5,
  //   "client_id": 8,
  //   "graph_type": "Spokesperson",
  //   "entity_level": true,
  //   "publication_level": false,
  //   "journalist_level": true,
  //   "city_level": false,
  //   "keyword_level": false,
  //   "spokesperson_level": false,
  //   "profiling_level": true,
  //   "visibility_level": false,
  //   "topic_level": true,
  //   "client_name": "Tata Motors",
  //   "graph_id": 5
  // },
  {
    id: 6,
    client_id: 8,
    graph_type: "Sentiment",
    entity_level: true,
    publication_level: true,
    journalist_level: true,
    city_level: true,
    keyword_level: true,
    spokesperson_level: false,
    profiling_level: false,
    visibility_level: false,
    topic_level: false,
    client_name: "Tata Motors",
    graph_id: 6,
  },
  // {
  //   "id": 7,
  //   "client_id": 8,
  //   "graph_type": "Keyword Analysis",
  //   "entity_level": true,
  //   "publication_level": true,
  //   "journalist_level": true,
  //   "city_level": true,
  //   "keyword_level": false,
  //   "spokesperson_level": true,
  //   "profiling_level": false,
  //   "visibility_level": false,
  //   "topic_level": false,
  //   "client_name": "Tata Motors",
  //   "graph_id": 7
  // },
  {
    id: 8,
    client_id: 8,
    graph_type: "Publication",
    entity_level: true,
    publication_level: false,
    journalist_level: true,
    city_level: false,
    keyword_level: true,
    spokesperson_level: false,
    profiling_level: false,
    visibility_level: false,
    topic_level: false,
    client_name: "Tata Motors",
    graph_id: 8,
  },
];

const mediaTypes = ["Print", "Print & Online", "Online"];

export default function QualitativeMain({ history }) {
  const dispatch = useDispatch();
  const [startRange, setStartRange] = useState(new Date());
  const [endRange, setEndRange] = useState(new Date());
  const [selectedTab, setSelectedTab] = useState("");
  const [selectedfilter, setSelectedFilter] = useState(undefined);
  const [applyFilterTS, setApplyFilterTS] = useState(new Date().getTime());
  const [showFilter, toggleFilter] = useState(false);
  const [hasWidgitInit, setHasWidgetInit] = useState(false);
  const [activeKey, setActiveKey] = useState(
    qualitativeSettings?.settings[0]["id"]
  );
  const [languageList, setLanguageList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [commonParams, setCommonParams] = useState({});
  const [selectAll, setSelectAll] = useState(true);
  const [selectedChartType, setSelectedChartType] = useState(
    QUALITATIVE_CHART_TYPE_FILTERS[0].value
  );
  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );
  const {
    entityDetails: { entityList = EMPTY_ARRAY },
  } = entityState || EMPTY_OBJECT;
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || EMPTY_OBJECT;
  const selectedClientId = selectedClient && selectedClient.id;
  const filterState =
    useSelector((state) => state.filterReducer) || EMPTY_OBJECT;
  const {
    publicationTypeFilter,
    entityFilter,
    editionFilter,
    reportsEntityFilter,
    socialEntityFilter,
    tonalityFilter,
  } = filterState;

  const [filters, setFilters] = useState({
    entity: EMPTY_ARRAY,
    publication: EMPTY_ARRAY,
    publication_type: EMPTY_ARRAY,
    typedPublication: EMPTY_STRING,
    edition: EMPTY_ARRAY,
    media_type: [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE],
    press_release: EMPTY_ARRAY,
    platform: EMPTY_ARRAY,
    country: EMPTY_ARRAY,
    languages: EMPTY_ARRAY,
    tonality: EMPTY_ARRAY,
    chartType: selectedChartType,
  });

  const [widgetParams, setWidgetParams] = useState({});
  const { media_type, entity } = filters;
  const dateHash = `${startRange}${endRange}`;

  const [qualitativeTypeSettings, setQualitativeTypeSettings] = useState({
    isPrintAndOnline: false,
    isPrint: false,
    isOnline: false,
  });
  const [selectedTypes, setSelectedTypes] = useState([]);
  const qualitativeSettings = useSelector(
    (state) => state.clientReducer.qualitativeSettings
  );

  const reportCategoryList = useMemo(
    () => getWidgetsBySettings(qualitativeSettings, qualitativeTypeSettings),
    [selectedClient, qualitativeTypeSettings]
  );

  const ANALYSIS_VERTICAL_OPTIONS =
    Array.isArray(qualitativeSettings.verticals) &&
    qualitativeSettings.isVertical
      ? qualitativeSettings.verticals.map((v) => {
          return { label: v, value: v };
        })
      : [];
  const qualitativeEnabled = useSelector(
    (state) => state.clientReducer.qualitativeSettings.qualitative
  );
  useEffect(() => {
    if (qualitativeEnabled === false) {
      history.push(DASHBOARD_CONTAINER);
    }
  }, [qualitativeEnabled]);

  useEffect(() => {
    const newQualitativeTypeSettings = {
      isPrintAndOnline: false,
      isPrint: false,
      isOnline: false,
    };
    if (selectedTypes.indexOf("Print") !== -1)
      newQualitativeTypeSettings.isPrint = true;
    if (selectedTypes.indexOf("Print & Online") !== -1)
      newQualitativeTypeSettings.isPrintAndOnline = true;
    if (selectedTypes.indexOf("Online") !== -1)
      newQualitativeTypeSettings.isOnline = true;
    setQualitativeTypeSettings(newQualitativeTypeSettings);
    console.log(selectedTypes);
  }, [selectedTypes]);

  useEffect(() => {
    const selectedTypesCurrent = [];
    if (qualitativeTypeSettings.isPrint) {
      selectedTypesCurrent.push("Print");
    }
    if (qualitativeTypeSettings.isOnline) {
      selectedTypesCurrent.push("Online");
    }
    if (
      qualitativeTypeSettings.isPrintAndOnline &&
      selectedTypesCurrent.length < 2
    ) {
      selectedTypesCurrent.push("Print & Online");
    }
    selectedTypes.length === 0 && setSelectedTypes(selectedTypesCurrent);
  }, [qualitativeTypeSettings]);

  useEffect(() => {
    if (qualitativeEnabled) {
      ANALYSIS_VERTICAL_OPTIONS.length > 0 &&
        setSelectedTab(ANALYSIS_VERTICAL_OPTIONS[0]);
      setActiveKey(qualitativeSettings?.settings[0]["id"]);
      qualitativeSettings &&
        setQualitativeTypeSettings({
          isPrintAndOnline: qualitativeSettings.isPrintOnline,
          isPrint: qualitativeSettings.isPrint,
          isOnline: qualitativeSettings.isOnline,
        });
    }
  }, [qualitativeSettings, qualitativeEnabled]);

  useEffect(() => {
    /* This is call the analysis only once at initial load. hence keeping the check to monitor that call is made just once.*/
    if (entity && entity.length && !hasWidgitInit && media_type) {
      handleApplyFilter();
      setHasWidgetInit(true);
    }
  }, [selectedClientId, entity]);

  useEffect(() => {
    //setSelectedChartType(filters.chartType);
    setWidgetParams({
      ...widgetParams,
      chartType: filters.chartType,
    });
  }, [filters.chartType]);

  useEffect(() => {
    setHasWidgetInit(false);
    // if (selectedTab.value === V_PRINT_AND_ONLINE) {
    //   setActiveKey(SOV);
    //   handleFilterSelect(VERTICAL, [V_PRINT, V_ONLINE]);
    // }
    // if (selectedTab.value === V_SOCIAL) {
    //   setActiveKey(SOV);
    //   handleFilterSelect(VERTICAL, [V_SOCIAL]);
    // }
    // if (selectedTab.value === V_BLOGS_AND_FORUMS) {
    //   setActiveKey(SOV);
    //   handleFilterSelect(VERTICAL, [V_BLOG, V_FORUM]);
    // }
    setWidgetParams({
      ...widgetParams,
      selectedVertical: selectedTab.value,
      selectedVerticalMain: selectedTab.value,
    });
    handleFilterSelect(VERTICAL, [V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE]);
  }, [selectedTab]);

  useEffect(() => {
    initEntityFilter();
  }, [reportsEntityFilter, socialEntityFilter]);

  useEffect(() => {
    if (media_type) {
      const callPTypeApi = isPrintAndOnline(media_type);
      setFilters((prevState) => {
        return {
          ...prevState,
          publication: EMPTY_ARRAY,
          publication_type: EMPTY_ARRAY,
          typedPublication: EMPTY_STRING,
          edition: EMPTY_ARRAY,
          media_type: filters.media_type,
          languages: EMPTY_ARRAY,
          tonality: EMPTY_ARRAY,
          platform: Object.values(SOCIAL_SOURCES),
        };
      });

      if (callPTypeApi) {
        if (!publicationTypeFilter) {
          dispatch(fetchPublicationIds(V_PRINT));
        }
      }
      initEntityFilter();
    }
  }, [media_type]);

  useEffect(() => {
    dispatch(fetchPressRelease(selectedClientId));
    fetchSocialLanguages();
  }, [selectedClient]);

  useEffect(() => {
    setWidgetParams({
      ...widgetParams,
      from_date: startRange,
      to_date: endRange,
    });
    initInlineFilters();
  }, [dateHash]);

  useEffect(() => {
    setWidgetParams((prevState) => {
      return {
        ...prevState,
        ...commonParams,
        chartType: filters.chartType,
      };
    });
  }, [commonParams]);

  const initInlineFilters = () => {
    const { entity, edition } = filters;
    dispatch(
      fetchInlineFilter({
        client_id: selectedClientId,
        media_type: V_ONLINE,
        entity,
        edition,
        to_date: endRange,
        from_date: startRange,
      })
    );
  };

  const initEntityFilter = () => {
    const entityListForFilter = getEntityFilterList();
    if (entityListForFilter) {
      if (selectAll) {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            entity: entityListForFilter.values.map((e) => e.id),
          };
        });
      } else {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            entity: [],
          };
        });
      }
    }
  };

  const initLanguageFilter = () => {
    if (languageList) {
      if (selectAll) {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            languages: languageList.map((l) => l.id),
          };
        });
      } else {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            languages: [],
          };
        });
      }
    }
  };
  const initPlatformFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return {
          ...prevState,
          platform: SOCIAL_SOURCES_OPTIONS.map((s) => s.id),
        };
      });
    } else {
      setFilters((prevState) => {
        return {
          ...prevState,
          platform: [],
        };
      });
    }
  };

  const initTonalityFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return {
          ...prevState,
          tonality: TONALITY_FILTER.values.map((l) => l.id),
        };
      });
    } else {
      setFilters((prevState) => {
        return {
          ...prevState,
          tonality: [],
        };
      });
    }
  };

  const handleFilterSelect = (name, value, resetAll) => {
    switch (name) {
      case EDITION: {
        if (resetAll) {
          setFilters({ ...filters, edition: [] });
          return;
        }
        let tempEntity = [...filters.edition];
        const editionList = editionFilter.values || [];
        const selectedEdition = editionList.filter((el) => el.id == value)[0];
        const existingSelectedEdition = tempEntity.filter(
          (el) => el.id == value
        )[0];
        if (!existingSelectedEdition) {
          tempEntity.push(selectedEdition);
          setFilters({ ...filters, edition: tempEntity });
        } else {
          tempEntity = tempEntity.filter((el) => el.id !== value);
          setFilters({ ...filters, edition: tempEntity });
        }
        break;
      }

      case PUBLICATION_TYPE: {
        if (resetAll) {
          setFilters({
            ...filters,
            publication_type: [],
            typedPublication: "",
            publication: [],
          });
          return;
        }
        const tempPublicationType = [...filters.publication_type];
        const elmIndex = tempPublicationType.indexOf(value);
        if (elmIndex === -1) {
          tempPublicationType.push(value);
          setFilters({ ...filters, publication_type: tempPublicationType });
        } else {
          tempPublicationType.splice(elmIndex, 1);
          setFilters({ ...filters, publication_type: tempPublicationType });
        }
        break;
      }

      case ENTITY: {
        if (resetAll) {
          setFilters({ ...filters, entity: [] });
          return;
        }
        const tempEntity = [...filters.entity];
        const elmIndex = tempEntity.indexOf(value);
        if (elmIndex === -1) {
          tempEntity.push(value);
          setFilters({ ...filters, entity: tempEntity });
        } else {
          tempEntity.splice(elmIndex, 1);
          setFilters({ ...filters, entity: tempEntity });
        }
        break;
      }

      case PUBLICATION_IDS: {
        if (resetAll) {
          setFilters({ ...filters, publication: "", typedPublication: "" });
          return;
        }
        if (filters.publication.filter((e) => e.id === value.id)[0]) {
          return;
        }
        setFilters({
          ...filters,
          publication: [...filters.publication, value],
          typedPublication: "",
        });
        break;
      }

      case TYPED_PUBLICATION_TEXT: {
        setFilters({ ...filters, typedPublication: value });
        break;
      }

      case REMOVE_PUBLICATION_TEXT: {
        const updatedArr = filters.publication.filter((e) => e.id !== value.id);
        setFilters({ ...filters, publication: updatedArr });
        break;
      }

      case VERTICAL: {
        if (resetAll) {
          setFilters({ ...filters, media_type: "" });
          return;
        }
        setFilters({ ...filters, media_type: value });
        break;
      }

      case PRESS_RELEASE: {
        if (resetAll) {
          setFilters({ ...filters, press_release: "" });
          return;
        }
        setFilters({ ...filters, press_release: value });
        break;
      }

      case PLATFORM: {
        const { platform = [] } = filters;
        if (resetAll) {
          setFilters({ ...filters, platform: [] });
          return;
        }
        const tempPlatform = platform ? platform : [];
        const elmIndex = tempPlatform.indexOf(value);
        if (elmIndex === -1) {
          tempPlatform.push(value);
          setFilters({ ...filters, platform: tempPlatform });
        } else {
          tempPlatform.splice(elmIndex, 1);
          setFilters({ ...filters, platform: tempPlatform });
        }
        break;
      }
      case LANGUAGES: {
        if (resetAll) {
          setFilters({ ...filters, languages: [] });
          return;
        }
        const tempLanguages = [...filters.languages];
        const elmIndex = tempLanguages.indexOf(value);
        if (elmIndex === -1) {
          tempLanguages.push(value);
          setFilters({ ...filters, languages: tempLanguages });
        } else {
          tempLanguages.splice(elmIndex, 1);
          setFilters({ ...filters, languages: tempLanguages });
        }
        break;
      }

      case TONALITY_MULT: {
        if (resetAll) {
          setFilters({ ...filters, tonality: [] });
          return;
        }
        const tempTonality = [...filters.tonality];
        const elmIndex = tempTonality.indexOf(value);
        if (elmIndex === -1) {
          tempTonality.push(value);
          setFilters({ ...filters, tonality: tempTonality });
        } else {
          tempTonality.splice(elmIndex, 1);
          setFilters({ ...filters, tonality: tempTonality });
        }
        break;
      }
      default:
    }
  };

  const handleDateChange = (date, type) => {
    const formattedDate = new Date(date);
    if (type === "start") {
      setStartRange(formattedDate);
    } else {
      setEndRange(formattedDate);
    }
  };

  const handleTypeClick = (t) => {
    if (selectedTypes.indexOf(t) > -1) return;
    const newSelected = [...selectedTypes];
    newSelected.shift();
    newSelected.push(t);
    setSelectedTypes(newSelected);
  };

  const resolveSentiment = (tone) => {
    const tempTone = TONALITY_FILTER.values.filter((t) => t.id == tone);
    if (tempTone && tempTone[0]) {
      return tempTone[0].value;
    }
    return null;
  };

  const handleApplyFilter = (e, isLimitChanged, customParams) => {
    if (customParams) {
      setStartRange(customParams.startDate);
      setEndRange(customParams.endDate);
    }
    setSelectedFilter(undefined);
    const {
      media_type,
      entity,
      publication,
      edition,
      publication_type,
      platform,
      tonality,
      languages,
      country,
      press_release,
    } = filters;
    initInlineFilters();
    let commonParams = {
      from_date: customParams ? customParams.startDate : startRange,
      to_date: customParams ? customParams.endDate : endRange,
      selectedVertical: media_type,
      topic_ids: entity,
      client_id: selectedClientId,
      user_id: getConceptUserId(),
    };
    const pAndOnline = isPrintAndOnline(media_type);
    if (pAndOnline) {
      commonParams = {
        ...commonParams,
        ...{
          selectedMainPublication: publication,
          publisher_type: publication_type,
          selectedMainEdition: edition,
          filterUpdateTS: new Date().getTime(),
          /* Since, the print and online graph api takes tonality ids as input.
          We need to map the names to ids in order to have modular code**/
          selectedMainSentiment: [...tonality],
          selectedMainPressRelease: press_release || null,
        },
      };
    }
    if (!pAndOnline) {
      commonParams = {
        ...commonParams,
        ...{
          channel_type: platform ? [...platform] : null,
          selectedMainSentiment:
            tonality && tonality.map((t) => resolveSentiment(t)),
          language: languages,
          selectedMainCountry: country,
        },
      };
    }
    setCommonParams(commonParams);
  };

  const showPrintFilters =
    media_type === V_PRINT || media_type === V_PRINT_AND_ONLINE;

  // const getCurrentReportCategoryList = () => {
  //   // if (selectedTab.value == V_PRINT_AND_ONLINE) {
  //   return reportCategoryList;
  //   // }
  //   // if (selectedTab.value == V_SOCIAL) {
  //   //   return socialReportCategoryList;
  //   // }
  //   // if (selectedTab.value == V_BLOGS_AND_FORUMS) {
  //   //   return blogsAndForumCategoryList;
  //   // }
  //   // return [];
  // };

  const getEntityFilterList = () => {
    if (
      media_type.indexOf(V_SOCIAL.toString()) !== -1 ||
      media_type.indexOf(V_BLOG.toString()) !== -1 ||
      media_type.indexOf(V_FORUM.toString()) !== -1 ||
      media_type.indexOf(V_SOCIAL) !== -1 ||
      media_type.indexOf(V_BLOG) !== -1 ||
      media_type.indexOf(V_FORUM) !== -1
    ) {
      return socialEntityFilter;
    }
    if (
      media_type.indexOf(V_PRINT.toString()) !== -1 ||
      media_type.indexOf(V_ONLINE.toString()) !== -1 ||
      media_type.indexOf(V_PRINT) !== -1 ||
      media_type.indexOf(V_ONLINE) !== -1
    ) {
      return reportsEntityFilter;
    }
  };

  const handleOnAccordianClick = (id, index) => {
    if (activeKey == id) {
      setActiveKey(null);
    } else {
      setActiveKey(id);
      const targetElm = document.getElementById(id);
      const scrollElement = document.querySelector(".accordionListWrap");
      if (targetElm && scrollElement) {
        const position = targetElm.getBoundingClientRect().top || 0;
        setTimeout(() => {
          scrollElement.scrollTo({
            top: position - (120 - 20 * index),
            behavior: "smooth",
          });
        }, 300);
      } else {
      }
    }
  };

  let fetchSocialLanguages = () => {
    selectedClientId &&
      httpGet(
        `${unifiedEnvConfig.LANGUAGES}?client_id=${selectedClientId}&perPage=100&page=0`
      )
        .then((response) => {
          const {
            data: { data },
          } = response;
          let tempList =
            data &&
            data
              .map((l) => {
                if (l && l != "und" && l != "null") {
                  return {
                    id: l,
                    language_name: LANGUAGE_CODES[l] || l,
                    value: l,
                  };
                }
              })
              .filter(Boolean);
          tempList = sortArrayOfObjects(tempList, "language_name");
          setLanguageList(tempList);
        })
        .catch((e) => {});

    httpGet(
      `${unifiedEnvConfig.COUNTRIES}?client_id=${selectedClientId}&perPage=100&page=0`
    )
      .then((response) => {
        const {
          data: { data = [] },
        } = response;
        const sortedData = data.sort();

        setCountryList(
          sortedData.map((c, index) => {
            return { id: c, country_name: c, value: c };
          })
        );
      })
      .catch((e) => {});
  };
  const mediaTypeFilter = useMemo(
    () => (
      <Dropdown
        key={selectedTypes[0]}
        className="dashboardDropdown media-type-dropdown"
      >
        <Dropdown.Toggle variant="default">
          {"Select Media Types"}
          <ArrowDownIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {mediaTypes.map((e, i) => {
            const selected = selectedTypes.indexOf(e) > -1 ? true : false;
            let className = selected
              ? "media-type selected-media-type"
              : "media-type";
            return (
              <>
                <Dropdown.Item key={i} onClick={() => handleTypeClick(e)}>
                  {e}
                  <div className={className}></div>
                </Dropdown.Item>
              </>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    ),
    [selectedTypes]
  );
  return (
    <>
      <div className="mainContainer analysisContainer">
        <div className="dashboardHeader dashboardHeading">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Qualitative Analysis</h1>
              </div>
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Qualitative Analysis</h1>
              {ANALYSIS_VERTICAL_OPTIONS.length > 0 && (
                <Dropdown
                  key={selectedTab.value}
                  className="dashboardDropdown verticalOptionDropdown"
                >
                  <Dropdown.Toggle variant="default">
                    {selectedTab.label || "Select Vertical"}
                    <ArrowDownIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {ANALYSIS_VERTICAL_OPTIONS.map((item) => {
                      return (
                        <Dropdown.Item
                          key={item.label}
                          onClick={() => {
                            setSelectedTab(item);
                            setSelectAll(true);
                          }}
                        >
                          {item.label}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
            <div className="titleRow analysisTitleRow">
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  {ANALYSIS_VERTICAL_OPTIONS.length > 0 && (
                    <Dropdown
                      key={selectedTab.value}
                      className="dashboardDropdown verticalOptionDropdown"
                    >
                      <Dropdown.Toggle variant="default">
                        {selectedTab.label || "Select Vertical"}
                        <ArrowDownIcon />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {ANALYSIS_VERTICAL_OPTIONS.length > 0 &&
                          ANALYSIS_VERTICAL_OPTIONS.map((item) => {
                            return (
                              <Dropdown.Item
                                onClick={() => {
                                  setSelectedTab(item);
                                  setSelectAll(true);
                                }}
                              >
                                {item.label}
                              </Dropdown.Item>
                            );
                          })}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  <DateRangeFilter
                    handleDateChange={handleDateChange}
                    startRange={startRange}
                    endRange={endRange}
                    showShortCut={false}
                    key="analysis"
                    minDate={selectedClient ? selectedClient.start_date : null}
                    maxDate={selectedClient ? selectedClient.end_date : null}
                    qualitative={true}
                    datePickerPlacement={"bottomStart"}
                  />
                  {mediaTypeFilter}
                  <button
                    onClick={() => toggleFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </div>
              </div>
              <div className="rightBtnContainer">
                <button
                  onClick={() => toggleFilter(true)}
                  className="btn filterBtn"
                >
                  <FilterIcon /> <span>Filters</span>
                </button>
                <div
                  className={`filtersWrap sideFilterWrap ${
                    showFilter ? "show" : "hide"
                  }`}
                >
                  <div className="filtersColumnWrap">
                    <Filters
                      toggleFilter={toggleFilter}
                      filters={filters}
                      setFilters={setFilters}
                      applyFilters={handleApplyFilter}
                      client_id={selectedClientId}
                      selectedVertical={selectedTab.value}
                      initEntityFilter={initEntityFilter}
                      initLanguageFilter={initLanguageFilter}
                      initPlatformFilter={initPlatformFilter}
                      initTonalityFilter={initTonalityFilter}
                      handleDateChange={handleDateChange}
                      startRange={startRange}
                      endRange={endRange}
                      isAnalysisMain
                      entityFilterList={getEntityFilterList()}
                      countryList={countryList}
                      languageList={languageList}
                      selectedTab={selectedTab.value}
                      hideDateRange
                      setSelectAll={setSelectAll}
                      selectedChartType={selectedChartType}
                      setSelectedChartType={setSelectedChartType}
                      chartTypeList={QUALITATIVE_CHART_TYPE_FILTERS}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <React.Fragment key={selectedTab.value}>
          {widgetParams && !!Object.keys(widgetParams).length && (
            <div
              className="accordion accordionListWrap analysisAccordionWrap"
              style={{ "margin-top": "33px" }}
            >
              {reportCategoryList.map((rc, index) => {
                if (!rc) {
                  return null;
                }
                return (
                  <div
                    className={
                      activeKey !== rc.id
                        ? "customAccordionRow card"
                        : "customAccordionRow card active"
                    }
                  >
                    <Sticky
                      scrollElement=".accordionListWrap"
                      boundaryElement=".customAccordionRow"
                      style={{ position: "relative" }}
                      hideOnBoundaryHit={false}
                    >
                      <div
                        className={`card-header ${
                          activeKey == rc.id ? "show" : ""
                        }`}
                        onClick={(e) => handleOnAccordianClick(rc.id, index)}
                        id={rc.id}
                      >
                        <button
                          id={rc.id}
                          type="button"
                          className="btn btn-link"
                        >
                          {rc.label}
                        </button>
                      </div>
                    </Sticky>

                    <div
                      className={`collapse ${
                        activeKey !== rc.id ? "hide" : "show"
                      }`}
                    >
                      <LazyLoad>
                        <div className="card-body">
                          <rc.component
                            key={rc.id}
                            embededEnabled={rc.embededEnabled}
                            widgetParams={widgetParams}
                            applyFilterTS={applyFilterTS}
                            filters={filters}
                            widgetList={rc.widgetList}
                            startRange={startRange}
                            endRange={endRange}
                          />
                        </div>
                      </LazyLoad>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </React.Fragment>
      </div>
    </>
  );
}
